import GA_AUTH_URL from './queries/GAAuthUrl.gql'
import CONNECT_GOOGLE from './queries/ConnectGoogle.gql'
import GOOGLE_GET_PROFILES from './queries/GoogleGetProfiles.gql'
import CONNECT_GOOGLE_ANALYTICS_OAUTH_INTEGRATION from './queries/ConnectGoogleAnalyticsOAuthIntegration.gql'
import UPDATE_GOOGLE_ANALYTICS_OAUTH_INTEGRATION from './queries/UpdateConnectionGoogleAnalyticsOAuthIntegration.gql'
import REMOVE_GOOGLE from './queries/RemoveGoogle.gql'
import { authClient, graphClient } from '@/main'

export default class {
    async connectGoogleAnalyticsOAuthIntegration (websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_GOOGLE_ANALYTICS_OAUTH_INTEGRATION,
            variables: {
                "website_id": websiteId,
                "property_id": propertyId,
                "profile_id": profileId,
                "is_always_push_page_views": isAlwaysPushPageViews,
                "send_disapprove_transactions": sendDisapproveTransactions
            }
        })
    }

    async updateGoogleAnalyticsOAuthIntegration (websiteId, propertyId, profileId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_GOOGLE_ANALYTICS_OAUTH_INTEGRATION,
            variables: {
                "website_id": websiteId,
                "property_id": propertyId,
                "profile_id": profileId,
                "is_always_push_page_views": isAlwaysPushPageViews,
                "send_disapprove_transactions": sendDisapproveTransactions
            }
        })
    }

    async gaAuthUrl () {
        return await graphClient.query({
            query: GA_AUTH_URL,
        })
    }

    async connectGoogle (code) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT_GOOGLE,
            variables: {
                code: code,
                websiteId: $cookies.get('website_id'),
            }
        })
    }

    async googleGetProfiles () {
        const websiteId = Number($cookies.get('website_id'))
        return await authClient.query({
            query: GOOGLE_GET_PROFILES,
            variables: {
                websiteId: websiteId
            }
        })
    }

    async removeGoogle (websiteId) {
        return await authClient.mutate({
            mutation: REMOVE_GOOGLE,
            variables: {
                websiteId: websiteId,
            }
        })
    }
}
